import { render } from "./CarouselPreview.vue?vue&type=template&id=24c0ec6b&scoped=true"
import script from "./CarouselPreview.vue?vue&type=script&lang=js"
export * from "./CarouselPreview.vue?vue&type=script&lang=js"

import "./CarouselPreview.vue?vue&type=style&index=0&id=24c0ec6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c0ec6b"]])

export default __exports__